import { useEffect, useState } from "react";
import { Outlet, useNavigate, useResolvedPath } from "react-router";
import NavStyles from "../Bilet/Bilet.module.css";
import { Button } from "@mui/material";

export default function News() {
  const defState = {
    news: false,
    category: false,
  };
  const [isActive, setActive] = useState({ ...defState });
  let path = useResolvedPath();
  useEffect(() => {
    const resolvedPath = path.pathname.split("/");
    setActive({ ...defState, [resolvedPath.slice(-1)]: true });
  }, [path.pathname]);
  const navHook = useNavigate();

  const handleNav = (e) => {
    const destanation = e.target.id;
    navHook(destanation);
  };
  return (
    <main>
      <div className={NavStyles.bilet_nav}>
        <Button
          disabled={isActive.news}
          onClick={handleNav}
          variant={isActive.news ? "contained" : "outlined"}
          id="/news">
          Новости
        </Button>
        <Button
          disabled={isActive.category}
          onClick={handleNav}
          variant={isActive.category ? "contained" : "outlined"}
          id="category">
          Категории
        </Button>
      </div>
      <Outlet />
    </main>
  );
}
